import React from 'react'
import cx from 'classnames'
import ToTopIcon from 'assets/icons/to-top.svg'
import styles from './ScrollButton.module.scss'

type ScrollButtonProps = {
  handleScrollToTop?: React.MouseEventHandler<HTMLButtonElement>
  scrollPosition?: { scrollTop: number } | null
  showFromTopPosition?: number
  containerClassName?: string
  buttonClassName?: string
}

export const ScrollButton = ({
  handleScrollToTop,
  scrollPosition,
  showFromTopPosition = 600,
  containerClassName,
  buttonClassName,
}: ScrollButtonProps) => {
  return (
    <div
      className={cx(styles.stickyContainer, {
        [styles.show]: (scrollPosition?.scrollTop ?? 0) > showFromTopPosition,
        [containerClassName ?? '']: Boolean(containerClassName),
      })}
    >
      <button
        className={cx(styles.scrollButton, buttonClassName)}
        onClick={handleScrollToTop}
      >
        <img src={ToTopIcon} alt="scroll to top" />
      </button>
    </div>
  )
}
